import React from 'react';
import {Toast} from 'antd-mobile';

let uuid = (function(){
    let id = 0;
    return ()=>{
        id++;
        return `file-id-${id}`;
    }
})();
class SelectFile extends React.Component{
    onChange = (evt)=>{
        let target = evt.currentTarget;
        let files = target.files;
        // 文件大小验证
        let validateFiles = [], invalidateFiles = [];
        for(let index = 0, len = files.length; index < len; index++){
            let file = files[index];
            if (file.size > (this.props.file_size_limit)){
                invalidateFiles.push(file);
            }else{
                file.id = uuid();
                validateFiles.push(file);
            }
        }
        
        let select = this.props.select;
        select && select(validateFiles);
        // 大小不符合规定
        if (invalidateFiles.length){
            let errorStr = []
            for (let file of invalidateFiles){
                errorStr.push(file.name);
            }
            Toast.info(`${errorStr.join(',') + $st("超过文件大小限制")}`, 2);
        }
    }
    
    render(){
        return (
            <div className="upload-file">
                {$st('上传附件')}
                <input type='file' title={$st("上传附件")} onChange={this.onChange} value={''} />
            </div>
        )
    }
}
export default SelectFile;


// WEBPACK FOOTER //
// ./src/component/FileAttachment/SelectFile.js